module.exports = __webpack_public_path__ + "static/media/Plantype.25a09a88.pdf";